<script setup lang="ts">
import Modal from '~/components/common/ModalV2.vue'
import SummaryTableNewPortal from '~/components/price-assessments/SummaryTableNewPortal.vue'
import type { TGeneral } from '~/src/types/common'

const props = withDefaults(
  defineProps<{
    productName: string
    summaries?: TGeneral[]
  }>(),
  {
    summaries: () => [],
  },
)

const modalStore = useModalStore()

const isOpen = computed(() => modalStore.getModal('allPricesTable'))

const onClose = () => {
  modalStore.close('allPricesTable')
}

watch(isOpen, async (isOpen) => {
  if (!isOpen) return

  setTimeout(() => {
    const element = document.getElementById(
      `product-name-${props.productName}`,
    ) as HTMLDivElement

    if (!element) return

    element.scrollIntoView({ behavior: 'smooth', inline: 'start' })
  }, 500)
})
</script>

<template>
  <Modal
    :is-open="isOpen"
    name="allPricesTable"
    modal-classes="max-w-[1232px] py-0 overflow-auto flex flex-col relative w-full rounded-xl bg-white px-0 shadow-dp-01 max-h-[85vh] lg:max-h-[96vh] relative top-2"
    content-classes="h-full overflow-auto py-4 px-2 md:pl-10"
    header-classes="md:pl-10 px-6 py-6"
    @close="onClose"
  >
    <template #header>
      <h3 class="text-h3 pr-6">Access the following Prices</h3>
    </template>

    <div class="relative overflow-x-auto">
      <div
        class="min-w-[1300px] bg-white lg:min-w-[400px] lg:max-w-2xl xl:min-w-[1000px] xl:max-w-none pr-2"
      >
        <SummaryTableNewPortal
          v-if="summaries?.length"
          class="w-auto lg:w-[1000px] xl:w-auto"
          disable-frequency-by-series
          show-product-name
          :price-summary="summaries"
          category="lithium"
        />
      </div>
    </div>
  </Modal>
</template>
